module.exports = __webpack_public_path__ + "media/buy-now/bag10-364b563a.png";